import React from 'react';
import PropTypes from 'prop-types';
import {Button} from '@learningblocks/shared-components';
import {Icons} from '@learningblocks/exp-constants';
import {Colours} from '@learningblocks/shared-components';
import style from './style.module.scss';

const {IconStart} = Icons;

/**
 * SelectButton:
 *  - Select Button for LevelSelector
 */
export function SelectButton(props) {
  const className = `${style.btn} ${props.className}`;
  return (
    <Button onClick={props.onClick} className={className}>
      <IconStart />
      {props.label}
    </Button>
  );
}

SelectButton.propTypes = {
  /**
   * ClassName
   */
  className: PropTypes.string,
  /**
   * Callback for select button
   */
  onClick: PropTypes.func.isRequired,
  /**
   * Label for SelectButton
   */
  label: PropTypes.string,
};

SelectButton.defaultProps = {
  label: 'Start Simulation',
  className: '',
};
